import PolicyAuditDetail from '@totem/components/policyAudits/policyAuditDetail/PolicyAuditDetail';
import PolicyAuditReport from '@totem/components/policyAudits/policyAuditDetail/Report';
import AnalysisPage from '@totem/components/surveyV2/analysis/AnalysisPage';
import AnalysisReportPage from '@totem/components/surveyV2/analysisReport/AnalysisReportPage';
import AuditReportPage from '@totem/components/surveyV2/auditReport/AuditReportPage';
import FindingPage from '@totem/components/surveyV2/findings/FindingPage';
import FindingReportPage from '@totem/components/surveyV2/findingsReport/FindingReportPage';
import ScoringPage from '@totem/components/surveyV2/instanceDetail/score/ScoringPage';
import SurveyDetailPage from '@totem/components/surveyV2/instanceDetail/SurveyDetailPage';
import SurveyInstancesPage from '@totem/components/surveyV2/instances/SurveyInstancesPage';
import PoliciesPage from '@totem/components/surveyV2/policies/PoliciesPage';
import PolicyAuditReportPage from '@totem/components/surveyV2/policyAuditReport/PolicyAuditReportPage';
import SurveyTemplatePage from '@totem/components/surveyV2/templateDetails/SurveyTemplatePage';
import TemplatesPage from '@totem/components/surveyV2/templates/TemplatesPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const surveyRoutes: Route[] = [
  {
    path: 'surveyinstances/:id/score',
    pageTitle: 'Survey Results',
    component: ScoringPage,
    exact: true,
    breadcrumbs: [{ label: 'Surveys', link: `/surveyinstances` }],
  },
  // Surveys V2
  {
    path: 'surveytemplates',
    pageTitle: 'Survey Templates',
    component: TemplatesPage,
    exact: true,
    breadcrumbs: [{ label: 'Survey Templates' }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'surveytemplates/:id',
    pageTitle: 'Survey Template Detail',
    component: SurveyTemplatePage,
    exact: true,
    breadcrumbs: [{ label: 'Survey Templates', link: `/surveytemplates` }],
    render: (userProfile: UserProfile) =>
      permissions.internal.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'surveyinstances',
    pageTitle: 'Survey Management',
    component: SurveyInstancesPage,
    exact: true,
    breadcrumbs: [{ label: 'Surveys' }],
    render: (userProfile: UserProfile) =>
      permissions.assessments.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'surveyinstances/:id',
    pageTitle: 'Survey Detail',
    component: SurveyDetailPage,
    exact: true,
    breadcrumbs: [{ label: 'Surveys', link: `/surveyinstances` }],
  },
  {
    path: 'surveyinstances/:id/report',
    pageTitle: 'Audit Report',
    component: AuditReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Surveys', link: '/surveyinstances' }],
  },

  {
    path: 'policies/v2',
    pageTitle: 'Policies',
    component: PoliciesPage,
    exact: true,
    breadcrumbs: [{ label: 'Policies' }],
    render: (userProfile: UserProfile) =>
      permissions.assessments.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  // Policy Audits - Original
  {
    path: 'policyaudits/v2',
    pageTitle: 'Policy Audit Management',
    component: PolicyAuditReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Audits', link: '/policyaudits/v2' }],
    render: (userProfile: UserProfile) =>
      permissions.assessments.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'policyaudits/:id',
    pageTitle: 'Policy Audit Detail',
    component: PolicyAuditDetail,
    exact: true,
    breadcrumbs: [{ label: 'Audits', link: '/policyaudits/v2' }],
  },
  {
    path: 'policyaudits/:id/report',
    pageTitle: 'Audit Report',
    component: PolicyAuditReport,
    exact: true,
    breadcrumbs: [{ label: 'Audits', link: '/policyaudits/v2' }],
  },
  {
    path: 'findings/policyaudits',
    pageTitle: 'Audit Analysis',
    component: AnalysisReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Audit Analysis' }],
    render: (userProfile: UserProfile) =>
      permissions.assessments.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  // Policy Audits V2
  {
    path: 'findings/policyaudits/v2',
    pageTitle: 'Audit Analysis',
    component: AnalysisPage,
    exact: true,
    breadcrumbs: [{ label: 'Audit Analysis' }],
    render: (userProfile: UserProfile) =>
      permissions.assessments.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'findings/policyaudits/v2/:questionId',
    pageTitle: 'Audit Analysis',
    component: FindingPage,
    exact: true,
    breadcrumbs: [
      { label: 'Audit Analysis', link: `/findings/policyaudits` },
      { label: 'Audit Analysis Details' },
    ],
  },
  {
    path: 'findings/policyaudits/v3/:question',
    pageTitle: 'Audit Analysis',
    component: FindingReportPage,
    exact: true,
    breadcrumbs: [
      { label: 'Audit Analysis', link: `/findings/policyaudits` },
      { label: 'Audit Analysis Details' },
    ],
  },
];
